import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfPen,
  PdfColor,
  PdfPoint,
  PdfRect,
  PdfFont,
  PdfBrush,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { ILayoutBaseGen } from '../layoutBase';
import { OptsBase } from '../optsBase';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/cut';
import { GUtil } from '../../pdf/gutil';
import { GeoBoard } from '../../pdf/board/geoboard';
import { generateMaze, drawMaze } from '../../core/maze';
import { C } from '../../core/c';
import { Random } from '@educraft/base';

/**
 * Base class for GeoBoard maze exercises (Bludiste = Labyrinth)
 * Draws a geoboard with an overlaid maze
 */
abstract class GeoBoard_Bludiste1_Base implements ILayoutBaseGen {
  constructor(protected readonly board: GeoBoard) {}

  public async generate(pdf: PdfGen, opts: OptsBase): Promise<void> {
    const page = pdf.addPage();

    const hintText = opts.data.lang.GeoBoard_Bludiste ?? 'Bludiště';
    page.drawString(
      hintText,
      GUtil.baseFont,
      PdfBrush.Black,
      null,
      new PdfRect(PdfUnit.FromMillimeters(5), PdfUnit.FromMillimeters(5), 50, 10),
      ETextAlign.TopLeft
    );

    // Generate maze
    const mazeWidth = this.board.width * 2 - 1;
    const mazeHeight = this.board.height * 2 - 1;
    const maze = generateMaze(opts.data.random, mazeWidth, mazeHeight);

    // Draw the geoboard
    this.board.draw(page);

    // Draw the maze
    const startPoint = new C(1, 0);
    const endPoint = new C(mazeWidth - 2, mazeHeight - 1);
    drawMaze(page, maze, this.board.rect, GUtil.basePen, startPoint, endPoint);
  }
}

/**
 * 8x8 GeoBoard maze variant 1
 */
export class GeoBoard__8__Bludiste1 extends GeoBoard_Bludiste1_Base {
  constructor() {
    super(GeoBoard.Board8());
  }
}

/**
 * 9x20 GeoBoard maze variant 1
 */
export class GeoBoard__920__Bludiste1 extends GeoBoard_Bludiste1_Base {
  constructor() {
    super(GeoBoard.Board920());
  }
}

/**
 * Base class for GeoBoard maze exercises variant 2
 * Uses a different maze generation or display pattern
 */
abstract class GeoBoard_Bludiste2_Base implements ILayoutBaseGen {
  constructor(protected readonly board: GeoBoard) {}

  public async generate(pdf: PdfGen, opts: OptsBase): Promise<void> {
    const page = pdf.addPage();

    const hintText = opts.data.lang.GeoBoard_Bludiste ?? 'Bludiště';
    page.drawString(
      hintText,
      GUtil.baseFont,
      PdfBrush.Black,
      null,
      new PdfRect(PdfUnit.FromMillimeters(5), PdfUnit.FromMillimeters(5), 50, 10),
      ETextAlign.TopLeft
    );

    // Generate maze with different parameters for variant 2
    const mazeWidth = this.board.width * 2 + 1;
    const mazeHeight = this.board.height * 2 + 1;
    const maze = generateMaze(opts.data.random, mazeWidth, mazeHeight);

    const rect = new PdfRect(
      this.board.rect.left - this.board.distance / 2,
      this.board.rect.top - this.board.distance / 2,
      this.board.width * this.board.distance,
      this.board.height * this.board.distance
    );

    // Draw the geoboard
    this.board.draw(page);

    // For variant 2, draw maze with different entry/exit points
    const startPoint = new C(mazeWidth - 2, 0);
    const endPoint = new C(1, mazeHeight - 1);
    drawMaze(page, maze, rect, GUtil.basePen, startPoint, endPoint);
  }
}

/**
 * 8x8 GeoBoard maze variant 2
 */
export class GeoBoard__8__Bludiste2 extends GeoBoard_Bludiste2_Base {
  constructor() {
    super(GeoBoard.Board8());
  }
}

/**
 * 9x20 GeoBoard maze variant 2
 */
export class GeoBoard__920__Bludiste2 extends GeoBoard_Bludiste2_Base {
  constructor() {
    super(GeoBoard.Board920());
  }
}
